<div [class.alternative]="otherTheme">
  <div class="example-container">
    <mat-toolbar color="primary" class="toolbar">
      <mat-checkbox
        matTooltip="Menü Sabitleme"
        [(ngModel)]="fixedMenu"
        (change)="fixedMenuChange($event)"
        ><mat-icon style="color: white">pin_end</mat-icon>></mat-checkbox
      >

      <button mat-button (click)="snav.toggle()">
        <mat-icon style="color: white">menu</mat-icon>
      </button>
      <a [routerLink]="['dashboard']">
        <img style="width: 25px; margin-top: 8px" src="{{ miniToolbarLogo }}" />
      </a>
      <!-- <button mat-button (click)="fastTransactions()">Hızlı İşlemler</button> -->
      <span style="margin-left: 10px; font-size: small">
        {{ changeCustomerTitle }} / {{ changeCustomerIdentity }}</span
      >
      <span class="fill-remaining-space"></span>
      <!-- 
    <mat-icon style="color: white;">account_circle</mat-icon>
    <span style="font-size: 11px; margin-right: 60px; color: white;" >{{userName}}</span> -->
      <ejs-dropdownlist
        color="primary"
        id="ddlelement"
        [dataSource]="customerChangeData"
        (change)="customerChange($event)"
        floatLabelType="Auto"
        [fields]="fields"
        [value]="value"
        popupHeight="200px"
        popupWidth="550px"
        allowFiltering="true"
      ></ejs-dropdownlist>
      &nbsp;&nbsp;
      <mat-slide-toggle
        matTooltip="{{ 'SIDENAV.CUSTOMER_SLIDE_TOOGLE_TOOL_TIP' | translate }}"
        (change)="slideToggleChange($event)"
        style="font-size: 9px"
        [(ngModel)]="defaultCustomerForSlideToggle"
      >
        <!--  <mat-icon color="primary">where_to_vote</mat-icon> -->
      </mat-slide-toggle>
      &nbsp; &nbsp; &nbsp;
      <button
        color="primary"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon style="color: white">account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          [class.alternative]="otherTheme"
          mat-menu-item
          (click)="userInfo()"
        >
          <mat-icon color="primary">account_box</mat-icon>
          <!-- <span>{{ userName }}</span> -->
          <span>Kullanıcı Bilgileri</span>
        </button>
        <button
          [class.alternative]="otherTheme"
          mat-menu-item
          (click)="changePassword()"
        >
          <mat-icon color="primary">vpn_key</mat-icon>
          <span>Şifre Değiştir</span>
        </button>
        <button
          [class.alternative]="otherTheme"
          mat-menu-item
          (click)="changeTheme()"
          color="primary"
        >
          <mat-icon color="primary">format_paint</mat-icon>
          <span>Tema Değiştir</span>
        </button>
      </mat-menu>

      <button style="margin: 17px" mat-button (click)="onLogout()">
        <mat-icon style="color: white">logout</mat-icon>
      </button>
    </mat-toolbar>
    <!-- 0683c6b8; -->
    <!-- [style.marginTop.px]="mobileQuery.matches ? 56 : 0" -->
    <mat-sidenav-container
      class="example-sidenav-container"
      [style.marginTop.px]="mobileQuery.matches ? 56 : 0"
      [hasBackdrop]="'false'"
    >
      <!-- [mode]="mobileQuery.matches ? 'over' : 'side'" -->
      <!-- [fixedInViewport]="mobileQuery.matches" -->
      <!-- fixedTopGap="56" -->
      <mat-sidenav
        #snav
        [mode]="mobileQuery.matches ? 'side' : 'side'"
        opened
        class="example-sidenav"
        style="background-color: white"
        [fixedInViewport]="'false'"
        fixedTopGap="0"
        [ngStyle]="{ 'width.em': sidenavWidth }"
        (mouseenter)="mouseenter()"
        (mouseleave)="mouseleave()"
      >
        <mat-nav-list [ngStyle]="{ 'width.em': sidenavChildWidth }">
          <!-- <span *ngFor="let item of mainmenu">
            <span *ngIf="!item.children || item.children.length === 0">
              <mat-list-item  [routerLink]="[item.route]">
                <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div>
                 <mat-icon color="primary">{{item.iconName}}</mat-icon>
                      <div fxFlex="10"></div>
                      <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{item.displayName | translate}}
                      </div>
              </mat-list-item>
            </span>
          </span> -->
          <span *ngIf="isAdmin">
            <span *ngFor="let item of partnerOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="partnerOrganizationPanelOpen = true"
                    (closed)="partnerOrganizationPanelOpen = false"
                    [expanded]="partnerOrganizationPanelOpen"
                    (click)="panelClickPartnerOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                           <mat-icon color="primary">{{item.iconName}}</mat-icon>
                          {{item.displayName}}
                        </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                           <mat-icon color="primary">{{child.iconName}}</mat-icon>
                          {{child.displayName}}
                        </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                     <mat-icon color="primary">{{item.iconName}}</mat-icon>
                    {{item.displayName}}
                  </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of companyOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="companyOrganizationPanelOpen = true"
                    (closed)="companyOrganizationPanelOpen = false"
                    [expanded]="companyOrganizationPanelOpen"
                    (click)="panelClickCompanyOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of userOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="userOrganizationPanelOpen = true"
                    (closed)="userOrganizationPanelOpen = false"
                    [expanded]="userOrganizationPanelOpen"
                    (click)="panelClickUserOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>

          <span *ngIf="isAdmin">
            <span *ngFor="let item of serviceActivisionOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="serviceActivisionOrganizationPanelOpen = true"
                    (closed)="serviceActivisionOrganizationPanelOpen = false"
                    [expanded]="serviceActivisionOrganizationPanelOpen"
                    (click)="panelClickServiceActivisionOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>

          <span *ngIf="isSystemAdmin">
            <span *ngFor="let item of parameterOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="parameterOrganizationPanelOpen = true"
                    (closed)="parameterOrganizationPanelOpen = false"
                    [expanded]="parameterOrganizationPanelOpen"
                    (click)="panelClickParameterOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of agreementOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="agreementOrganizationPanelOpen = true"
                    (closed)="agreementOrganizationPanelOpen = false"
                    [expanded]="agreementOrganizationPanelOpen"
                    (click)="panelClickAgreementOrganization()"
                    class="main-color"
                  >
                    <mat-expansion-panel-header class="main-color">
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                        <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                        <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                  <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of contourOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="contourOrganizationPanelOpen = true"
                    (closed)="contourOrganizationPanelOpen = false"
                    [expanded]="contourOrganizationPanelOpen"
                    (click)="panelClickContourOrganization()"
                    class="main-color"
                  >
                    <mat-expansion-panel-header class="main-color">
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                        <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                        <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                  <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of systemOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="systemOrganizationPanelOpen = true"
                    (closed)="systemOrganizationPanelOpen = false"
                    [expanded]="systemOrganizationPanelOpen"
                    (click)="panelClickSystemOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <span *ngIf="item.children[0]">
                      <mat-accordion>
                        <mat-expansion-panel
                          *ngFor="let child of item.children"
                          style="padding: -1px; margin-left: -5px"
                        >
                          <mat-expansion-panel-header style="font-size: 11px">
                            <mat-panel-title>
                              <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                          <mat-icon>{{item.iconName}}</mat-icon>
                          {{item.displayName}}
                        </div> -->
                              <mat-icon color="primary">{{
                                child.iconName
                              }}</mat-icon>
                              <div fxFlex="10"></div>
                              <div
                                *ngIf="sidenavWidth > 6"
                                class="sidenav-item"
                              >
                                {{ child.displayName | translate }}
                              </div>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <span *ngFor="let childItem of child.children">
                            <span *ngIf="childItem">
                              <span *ngIf="childItem?.isPermisson">
                                <mat-list-item
                                  [disabled]="childItem?.disabled"
                                  style="font-size: 10px"
                                  [routerLink]="[childItem.route]"
                                >
                                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                            <mat-icon>{{child.iconName}}</mat-icon>
                            {{child.displayName}}
                          </div> -->
                                  <mat-icon color="primary">{{
                                    childItem.iconName
                                  }}</mat-icon>
                                  <div fxFlex="10"></div>
                                  <div
                                    *ngIf="sidenavChildWidth > 8"
                                    class="sidenav-item"
                                  >
                                    {{ childItem.displayName | translate }}
                                  </div>
                                </mat-list-item>
                              </span>
                            </span>
                          </span>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </span>

                    <!-- <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span> -->
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of accountingOrganizationMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="accountingOrganizationPanelOpen = true"
                    (closed)="accountingOrganizationPanelOpen = false"
                    [expanded]="accountingOrganizationPanelOpen"
                    (click)="panelClickAccountingOrganization()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
          <span *ngIf="isAdmin">
            <span *ngFor="let item of reportMenu">
              <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                  <mat-expansion-panel
                    (opened)="reportPanelOpen = true"
                    (closed)="reportPanelOpen = false"
                    [expanded]="reportPanelOpen"
                    (click)="panelClickReport()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                      </div> -->
                        <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                        <div fxFlex="10"></div>
                        <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                          {{ item.displayName | translate }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span *ngFor="let child of item.children">
                      <span *ngIf="child.isPermisson">
                        <mat-list-item
                          style="font-size: 11px"
                          [routerLink]="[child.route]"
                        >
                          <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center" > 
                         <mat-icon color="primary">{{child.iconName}}</mat-icon>
                        {{child.displayName}}
                      </div> -->
                          <mat-icon color="primary">{{
                            child.iconName
                          }}</mat-icon>
                          <div fxFlex="10"></div>
                          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                            {{ child.displayName | translate }}
                          </div>
                        </mat-list-item>
                      </span>
                    </span>
                  </mat-expansion-panel>
                </mat-accordion>
              </span>
              <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item [routerLink]="[item.route]">
                  <!-- <div *ngIf="sidenavWidth > 6" fxLayout="row" fxLayoutAlign="space-between center">
                   <mat-icon color="primary">{{item.iconName}}</mat-icon>
                  {{item.displayName}}
                </div> -->
                  <mat-icon color="primary">{{ item.iconName }}</mat-icon>
                  <div fxFlex="10"></div>
                  <div *ngIf="sidenavWidth > 6" class="sidenav-item">
                    {{ item.displayName | translate }}
                  </div>
                </mat-list-item>
              </span>
            </span>
          </span>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <!-- color="primary" -->

        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
  <ng-template #userInfoDialog class="mat-dialog-container">
    <h5><b>KULLANICI BİLGİLERİ</b></h5>
    <p>
      <b>Ad : &nbsp;</b>
      {{ userInfoRes.name }}
    </p>
    <p>
      <b>Soyad : &nbsp;</b>
      {{ userInfoRes.surname }}
    </p>
    <p>
      <b>Email : &nbsp;</b>
      {{ userInfoRes.eMail }}
    </p>
    <p>
      <b>Cep Telefonu : &nbsp;</b>
      {{ userInfoRes.mobilePhone }}
    </p>
    <p>
      <b
        >Detaylı kullanıcı bilgilerini "Kullanıcı Listesi" ekranından
        görebilirsiniz &nbsp;</b
      >
    </p>
    <br />
    <button
      mat-button
      matDialogClose
      style="background-color: #4ed0d0; text-align: center"
      class="button"
      color="primary"
    >
      KAPAT
    </button>
  </ng-template>
</div>
